function initMtoVideoDialogs(root) {
  root.querySelectorAll('.mto-oval-categories__video-dialog').forEach(function (dialogComponent) {
    if (dialogComponent.dataset.mtoVideoBound) return;
    dialogComponent.dataset.mtoVideoBound = 'true';

    var wrap = dialogComponent.querySelector('[data-video-wrap]');
    if (!wrap) return;

    dialogComponent.addEventListener('dialog:open', function () {
      var source = wrap.dataset.videoSource;
      if (source === 'external') {
        if (wrap.querySelector('iframe')) return;
        var embed = wrap.querySelector('[data-embed-type]');
        if (!embed) return;
        var type = embed.dataset.embedType;
        var id = embed.dataset.embedId;
        var iframe = document.createElement('iframe');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        iframe.src =
          type === 'youtube'
            ? 'https://www.youtube.com/embed/' +
              id +
              '?autoplay=1&playsinline=1&rel=0&controls=0&loop=1&playlist=' +
              id
            : 'https://player.vimeo.com/video/' + id + '?autoplay=1&controls=0&loop=1';
        embed.appendChild(iframe);
      } else {
        var video = wrap.querySelector('video');
        if (video) {
          video.currentTime = 0;
          video.play().catch(function () {});
        }
      }
    });

    dialogComponent.addEventListener('dialog:close', function () {
      var iframe = wrap.querySelector('iframe');
      if (iframe) iframe.remove();
      var video = wrap.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  });
}

function initMtoDots(root) {
  root.querySelectorAll('.mto-oval-categories').forEach(function (component) {
    if (component.dataset.mtoDotsBound) return;
    if (!component.classList.contains('mto-oval-categories--layout-carousel')) return;
    if (component.dataset.showDotsDesktop !== 'true' && component.dataset.showDotsMobile !== 'true') return;

    var track = component.querySelector('.mto-oval-categories__track');
    var dotsContainer = component.querySelector('.mto-oval-categories__dots');
    if (!track || !dotsContainer) return;

    var items = Array.prototype.slice.call(track.children).filter(function (child) {
      return child.classList.contains('mto-oval-categories__item');
    });
    if (items.length < 2) return;

    component.dataset.mtoDotsBound = 'true';

    var dots = items.map(function (item, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mto-oval-categories__dot';
      dot.setAttribute('aria-label', String(index + 1));
      dot.addEventListener('click', function () {
        item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dotsContainer.appendChild(dot);
      return dot;
    });

    var setActive = function (index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    };

    var updateActiveFromScroll = function () {
      var trackLeft = track.scrollLeft;
      var closestIndex = 0;
      var closestDistance = Infinity;
      items.forEach(function (item, index) {
        var distance = Math.abs(item.offsetLeft - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      setActive(closestIndex);
    };

    updateActiveFromScroll();

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateActiveFromScroll();
          ticking = false;
        });
      },
      { passive: true }
    );
  });
}

initMtoVideoDialogs(document);
initMtoDots(document);
document.addEventListener('shopify:section:load', function (event) {
  initMtoVideoDialogs(event.target);
  initMtoDots(event.target);
});
